import { fetchIStatus } from '@/shared/fetchIStatus';

export const deleteChild = async (UID: string) => {
    const url = `/api/patients/kid/${UID}`;

    return await fetchIStatus<void, void>(url, 'DELETE');
};
